module.exports = __webpack_public_path__ + "img/banner-3.df913c1f.png";